export const LINKS = {
    ZOCDOC: "https://www.zocdoc.com/wl/myorcare/search",
    CLINIKO1: "https://myor-diagnostics-ltd.au2.cliniko.com/bookings?embedded=true",
    CLINIKO: "https://myor-diagnostics-ltd.au2.cliniko.com/bookings?practitioner_id=1346857407195650329&appointment_type_id=1435274074711399179",
    APPOINTMENT: "/appointment",
    CLIENT_SECURE: "https://myordietetics.clientsecure.me/request/location"
}